import { __assign } from 'tslib';
import React__default, { forwardRef, Children } from 'react';
import cn from 'classnames';
import Item from './Item.js';

var styles = {"spaceContainer":"space__spaceContainer_ewr20","spaceContainerFullWidth":"space__spaceContainerFullWidth_ewr20","vertical":"space__vertical_ewr20","center":"space__center_ewr20","start":"space__start_ewr20","end":"space__end_ewr20","spaceItemFullWidth":"space__spaceItemFullWidth_ewr20","spaceItem":"space__spaceItem_ewr20","wrap":"space__wrap_ewr20","divider":"space__divider_ewr20"};
require('./index.css');

var SpaceSizes = {
    s: 12,
    m: 16,
    l: 20,
};
var getNumberSize = function (size) { return (typeof size === 'string' ? SpaceSizes[size] : size || 0); };
/**
 * Позаимствовано с благодарностью из Ant Design
 */
var Space = forwardRef(function (props, ref) {
    var _a, _b, _c;
    var children = props.children, className = props.className, _d = props.align, align = _d === void 0 ? 'start' : _d, _e = props.direction, direction = _e === void 0 ? 'vertical' : _e, _f = props.size, size = _f === void 0 ? 'm' : _f, _g = props.wrap, wrap = _g === void 0 ? false : _g, _h = props.divider, divider = _h === void 0 ? false : _h, _j = props.fullWidth, fullWidth = _j === void 0 ? false : _j, dataTestId = props.dataTestId, _k = props.useCssGaps, useCssGaps = _k === void 0 ? false : _k;
    var _l = React__default.useMemo(function () {
        return (Array.isArray(size) ? size : [size, size]).map(function (item) {
            return getNumberSize(item);
        });
    }, [size]), horizontalSize = _l[0], verticalSize = _l[1];
    var childNodes = Children.toArray(children);
    if (childNodes.length === 0) {
        return null;
    }
    var directionClassName = styles[direction];
    var alignClassName = styles[align];
    var containerClassName = cn(styles.spaceContainer, directionClassName, (_a = {},
        _a[alignClassName] = align,
        _a[styles.spaceContainerFullWidth] = fullWidth,
        _a), className);
    var itemClassName = cn(styles.spaceItem, (_b = {},
        _b[styles.spaceItemFullWidth] = fullWidth,
        _b));
    var nodes = childNodes.map(function (child, i) { return (
    /* eslint-disable react/no-array-index-key */
    React__default.createElement(Item, { className: itemClassName, dividerClassName: styles.divider, key: "".concat(itemClassName, "-").concat(i), direction: direction, horizontalSize: horizontalSize, verticalSize: verticalSize, length: childNodes.length, index: i, wrap: wrap, divider: divider, useCssGaps: useCssGaps }, child)
    /* eslint-enable */
    ); });
    return (React__default.createElement("div", { "data-test-id": dataTestId, className: cn(containerClassName, (_c = {},
            _c[styles.wrap] = useCssGaps && wrap,
            _c)), style: __assign(__assign({}, (useCssGaps && {
            columnGap: horizontalSize / (divider ? 2 : 1),
            rowGap: verticalSize / (divider ? 2 : 1),
        })), (wrap && !useCssGaps && { flexWrap: 'wrap', marginBottom: -verticalSize })), ref: ref }, nodes));
});

export { Space };
